import { useUserStore } from "@/modules/auth/store/user";
import { ProgressBar } from "./ProgressBar";
import { getNextPromoCapAndRank } from "@/modules/user/types/wallet";
import { useTranslation } from "react-i18next";
import Skeleton from "@/components/common/Skeleton";

const PromoProgress = () => {
  const { t } = useTranslation();
  const { matchingBonus, isMatchingBonusLoading } = useUserStore();

  const { cap, code } = getNextPromoCapAndRank(matchingBonus.promoTurnover);

  return (
    <>
      <div className="w-full flex flex-col items-center bg-bg rounded-[0.75rem]">
        <div className="w-full flex flex-col p-4 gap-3">
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            <span className="font-semibold">{t("bonus-page.rank")}:</span>{" "}
            {isMatchingBonusLoading ? (
              <Skeleton className="inline-block align-middle w-10 h-4.5" />
            ) : (
              <span className="uppercase">
                {matchingBonus.rank.current.title}
              </span>
            )}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            <span className="font-semibold">
              {t("bonus-page.fl_promo_turnover", {
                rank: code,
              })}
              :
            </span>{" "}
            {isMatchingBonusLoading ? (
              <Skeleton className="inline-block align-middle w-10 h-4.5" />
            ) : (
              <span>
                ${Math.floor(matchingBonus.promoTurnover * 100) / 100}/{cap}
              </span>
            )}
          </p>

          {isMatchingBonusLoading ? (
            <Skeleton className="w-full h-2" />
          ) : (
            <ProgressBar value={matchingBonus.promoTurnover} max={cap} />
          )}
        </div>
      </div>
    </>
  );
};

export default PromoProgress;
